import { Button, View } from '@zinc/ui';
import './style.css';

import React from 'react';

export default class extends React.Component {
  static defaultProps = {
    keys: '',
    className: ''
  };

  render() {
    const sections = this.props.keys.split('\n').map((s, idx) => {
      const keys = s.split('').map((k, i) => {
        return (
          <span className="key" key={i}>
            <Button
              size="large"
              variant="outline"
              className={this.props.className}
              onClick={this.onClick.bind(this, k)}
            >
              {k}
            </Button>
          </span>
        );
      });

      return (
        <View key={idx} gap={2} direction="row" wrap>
          {keys}
        </View>
      );
    });

    return (
      <View padding={2} gap={2} className="keyboard">
        {sections}
      </View>
    );
  }

  shouldComponentUpdate(props) {
    return this.props.keys !== props.keys;
  }

  onClick = (key, e) => {
    e.preventDefault();
    return this.props.onClick != null ? this.props.onClick.call(this, key) : undefined;
  };
}
